var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4941 8.83902C13.1683 8.50579 13.1683 7.4943 12.4937 7.1615L4.49117 3.2407C4.16794 3.08233 3.69124 2.96078 3.33763 3.02798C2.5298 3.1815 3.21416 4.37548 3.6222 5.08939L4.60274 6.80494C4.85137 7.23996 5.29853 7.52438 5.79792 7.56517L8.65766 7.79875C8.8791 7.83151 8.8791 8.16866 8.65765 8.20142L5.7985 8.43482C5.29875 8.47561 4.85127 8.76024 4.60246 9.19557L3.62232 10.9105C3.21432 11.6244 2.52972 12.8183 3.33749 12.9719C3.69126 13.0392 4.16809 12.9176 4.49148 12.7591L12.4941 8.83902Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.c0d3589115e1c3233f7d6424d3f28327.svg";
export { ForwardRef as ReactComponent };